import classNames from "classnames/bind";
import styles from "./OnwardLinks.module.scss";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";

export type OnwardLink = {
  title: string;
  url: string;
  imageUrl?: string;
};

type Props = {
  onwardLinks: OnwardLink[];
};

export const OnwardLinksUI = ({ onwardLinks }: Props) => {
  const cx = classNames.bind(styles);

  return (
    <div className={styles.container}>
      <h2>More like this</h2>
      <ul className={styles.onwardLinks}>
        {onwardLinks.map((link: OnwardLink, i) => {
          return (
            <li
              className={cx(
                "onwardLink",
                { loading: link.title === "" },
                { content: link.title !== "" },
              )}
              key={i}
            >
              <UnderlinedButton
                className={styles.externalButton}
                tag="a"
                target="_blank"
                rel="noreferrer"
                href={link.url}
              >
                {link.imageUrl && <img src={link.imageUrl} alt={link.title} />}
                <span>{link.title}</span>
              </UnderlinedButton>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
